import { useGetAppFeatures } from '../redux/api/appConfigApi';
import { AppFeatureKey } from '../shared/constants';

export function useFeature() {
  const {
    data: features,
    isFetching,
    isLoading: isAppFeaturesLoading,
  } = useGetAppFeatures();

  return {
    isFetching,
    /** True until the first app-features response is available (initial load). */
    isAppFeaturesLoading,
    [AppFeatureKey.resourses]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.resourses)?.isActive ??
        true),
    [AppFeatureKey.restrictions]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.restrictions)?.isActive ??
        true),
    [AppFeatureKey.subscriptions]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.subscriptions)?.isActive ??
        true),
    [AppFeatureKey.donations]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.donations)?.isActive ??
        false),
    [AppFeatureKey.appleAuthorization]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.appleAuthorization)
        ?.isActive ??
        true),
    [AppFeatureKey.facebookAuthorization]:
      !!features &&
      (features?.find((f) => f.key === AppFeatureKey.facebookAuthorization)
        ?.isActive ??
        false),
  };
}
